export const FORM_TYPE_KEY = 'hjbc.FormType'
export const FORM_STEP_KEY = 'hjbc.FormStep'
export const PERSONAL_DATA_STEP_KEY = 'hjbc.PersonalDataStep'
export const FORM_ID_KEY = 'hjbc.id'
export const FORM_EMAIL_KEY = 'hjbc.email'
